import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';

configure({ enforceActions: 'always' });

class F1SessionStore extends LocalModel {
    constructor() {
        super('f1Session', {
            namePlural: 'f1Sessions',
            namePluralReal: 'f1sessions',
            sort: '-dateStart',
            limit: 100,
            api: {
                search: {
                    url: '/api/f1sessions/',
                    params: {
                        limit: 100,
                        sort: '-dateStart',
                    },
                },
                load: {
                    url: '/api/f1sessions/',
                    params: {},
                },
                save: {
                    url: '/api/f1sessions/',
                    params: {},
                },
                delete: {
                    url: '/api/f1sessions/',
                    params: {},
                },
            },
        });
    }

    @observable f1Sessions = [];

    @observable f1Session = {};

    @observable newF1Session = {};
}

const store = new F1SessionStore();
export default store;
